exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desc {\n  display: inline-block;\n  text-align: left;\n  max-width: 280px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/onboarding-hdr/onboarding-hdr.component.scss
// module id = ../../../../../src/app/brds/widgets/onboarding-hdr/onboarding-hdr.component.scss
// module chunks = 10